define.alias("ember-math-helpers/helpers/mult", "preview-grid/helpers/mult");